<template>

    <m-edit1/>

    <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-11 mx-auto mt-2 text-center" >
                <template #default>(ارسال بصورت پس کرایه می باشد)   </template>
                </m-Alert-1><m-factor-4 v-bind='{...{"sellerName":"\u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u0633\u0631\u0627\u06cc \u0642\u0644\u0645","addressProp":"\u062e\u0648\u0632\u0633\u062a\u0627\u0646 - \u062f\u0632\u0641\u0648\u0644 - \u062e\u06cc\u0627\u0628\u0627\u0646 \u0634\u0631\u06cc\u0639\u062a\u06cc \u062a\u0642\u0627\u0637\u0639 \u0622\u0641\u0631\u06cc\u0646\u0634 \u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u0633\u0631\u0627\u06cc \u0642\u0644\u0645","meliProp":"","signature":"","secondImageFactor":""},...{}}' :style='""' class="" ></m-factor-4>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mAlert1,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
